export const formGenerationLayoutStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '18px',
};

export const formGenerationControlsStyles = {
  maxWidth: '480px',
};

export const formGenerationPreviewStyles = {
  width: '100%',
  height: '70vh',
  minHeight: '480px',
  borderRadius: '10px',
  // DocumentView enforces a 600px min-width; let the wrapper scroll instead of
  // silently clipping the page when the viewport is narrower than that.
  overflow: 'auto',
};

export const formGenerationPreviewPlaceholderStyles = {
  width: '100%',
  // Match the filled-preview height so the section doesn't jump when switching
  // between the empty placeholder and a generated document.
  height: '70vh',
  minHeight: '480px',
  borderRadius: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: ({ palette }) =>
    palette.mode === 'dark' ? palette.background.secondary : palette.grey[100],
  border: ({ palette }) => `1px solid ${palette.divider}`,
};
